export default () => ({
  pinPadWrapper: {
    width: '60%',
    margin: '0 auto',
  },
});
